import React from 'react';

import './SummaryTable.css';

const SummaryTable = ({ className, ...props }) => {
  className = `short-summary-table ${className || ''}`;
  return <table className={className} {...props}/>;
};

export default SummaryTable;
